import { type ColumnSort, toOrderByParams } from '@/utils/table/columnSort'

import type {
  ContractsFilterParams,
  ContractsFilters,
  ContractsSortField,
} from '../types/contracts.types'

export const INITIAL_CONTRACTS_FILTERS: ContractsFilters = {
  description: '',
  number: '',
}

const toSearchParam = (value: string) => value.trim() || undefined

export const toContractsFilterParams = (
  filters: ContractsFilters,
  sort: ColumnSort<ContractsSortField>
): ContractsFilterParams => ({
  description: toSearchParam(filters.description),
  number: toSearchParam(filters.number),
  ...toOrderByParams(sort),
})
